<template>
  <BFormGroup
    :label="translatedText(data.name) + (data.mandatory ? ' *' : '')"
    :label-for="`date-input-${data.key}`"
    :state="validation"
  >
    <BFormInput
        :id="`date-input-${data.key}`"
        :placeholder="translatedText(data.name)"
        :required="data.mandatory"
        :model-value="modelValue"
        :state="validation"
        type="date"
        @update:model-value="$emit('update:modelValue', $event)"
    />
  </BFormGroup>
</template>

<script setup>
import {computed} from "vue";
import {inputStatus} from "../validations";
import {translate} from "@/domain/utils/translations";

defineEmits(['update:modelValue'])

const props = defineProps({
  data: { type: Object, required: true },
  lang: { type: String, required: true },
  modelValue: { type: String, required: true },
  isSubmitted: {
    type: Boolean,
    required: true
  }
})

const validation = computed(() => inputStatus(props.data.type, props.data.mandatory, props.modelValue, props.isSubmitted))

const translatedText = (field) => translate(field, props.lang)

</script>